/** Preferred row order when present in data (legacy DDO DOE imports). */
export const CANONICAL_ACCESSORY_ORDER = [
  'Fléxible 70',
  'Fléxible 45',
  'Lance 70',
  'Lance 45',
  'Réduction 70/45',
  'Réduction 100/70',
  'Division 70',
  'Division 45',
  'Tricoise',
];

function sortAccessories(names) {
  const set = new Set(names);
  const ordered = CANONICAL_ACCESSORY_ORDER.filter((n) => set.has(n));
  const rest = [...set].filter((n) => !CANONICAL_ACCESSORY_ORDER.includes(n)).sort();
  return [...ordered, ...rest];
}

export function buildCabinetMatrix(placements = []) {
  const list = Array.isArray(placements) ? placements : [];
  const accessories = sortAccessories(list.map((p) => p.accessoryType).filter(Boolean));
  const locations = [...new Set(list.map((p) => p.location).filter(Boolean))].sort();
  const index = new Map();
  for (const row of list) {
    if (!row.accessoryType || !row.location) continue;
    index.set(`${row.accessoryType}\0${row.location}`, row);
  }
  const getAt = (accessoryType, location) => index.get(`${accessoryType}\0${location}`) || null;
  const totalQuantity = list.reduce((sum, p) => sum + (Number(p.quantity) || 0), 0);
  return { accessories, locations, getAt, totalQuantity, rowCount: list.length };
}

export function cabinetStatusClass(status) {
  switch (status) {
    case 'vérifié':
      return 'bg-green-100 text-green-800';
    case 'à vérifier':
      return 'bg-yellow-100 text-yellow-800';
    case 'urgent':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}
